import { Notification } from "element-ui";
import store from "@/store";
import i18n from "@/i18n";
import { globalWebSocketManager } from "@/utils/services/WebSocketService";
import { clearLocalStorageKeepSidebarPinned } from "@/utils/storage";

export const tokenExpired = () => {
  Notification({
    title: i18n.t("route.token-expired-title"),
    message: i18n.t("route.token-expired-message"),
    duration: 2000,
    type: "warning",
  });
  store.commit("authoState/CLEAR_AUTH_STATE");
  store.commit("authoState/setToken", "");
  clearLocalStorageKeepSidebarPinned();

  // token 清除后再关闭所有 WebSocket 连接：onclose 时登录态已失效，
  // 登录页连接不会重连；公共插码页仍按原逻辑保活。
  globalWebSocketManager.closeAllConnections();
};
